export function readIsRecentlyReactivated(value: unknown): boolean {
  if (value === true || value === 1 || value === 'true') {
    return true;
  }

  if (!value || typeof value !== 'object') {
    return false;
  }

  const record = value as Record<string, unknown>;
  const raw = record.is_reactivated ?? record.isReactivated ?? record.isRecentlyReactivated;
  if (raw === value) {
    return false;
  }

  return readIsRecentlyReactivated(raw);
}
